import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { HttpService } from '@app/core';
import { UserSelectorData, UserSelectorPanelNotes } from '@app/models';
import { GetOrgUserList, MemberUser } from '@app/models/user.model';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable()
export class UsersSelectorService {

  defaultUserSelectorData: UserSelectorData = {
    selectedUsers: [],
    confirmedUsers: []
  };
  private readonly _userSelectorData$: BehaviorSubject<UserSelectorData> = new BehaviorSubject<UserSelectorData>(this.defaultUserSelectorData);
  private readonly _panelOpened$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  private readonly _panelNotes$: BehaviorSubject<UserSelectorPanelNotes> = new BehaviorSubject<UserSelectorPanelNotes>({});
  private readonly _defaultFilters$: BehaviorSubject<{ [k:string]: any } | null> = new BehaviorSubject<{ [k:string]: any } | null>(null);
  private readonly _broadcastType$: BehaviorSubject<string | null> = new BehaviorSubject<string | null>(null);
  
  constructor(
    private readonly _httpService: HttpService,
    private readonly _router: Router
  ) { 
    this._router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.setUserSelectorData();
        this.setPanelStatus(false);
      }
    })
  }

  get userSelectorData() {
    return this._userSelectorData$;
  }

  setUserSelectorData(data: UserSelectorData = this.defaultUserSelectorData) {
    this._userSelectorData$.next(data);
  }

  get panelOpened() {
    return this._panelOpened$;
  }

  get broadcastType() {
    return this._broadcastType$;
  }

  setBroadcastType(data: string | null) {
    this._broadcastType$.next(data);
  }

  setPanelStatus(data: boolean, noSelectedNote?: string, defaultFilters?: { [k:string]: any }, broadcastType?: string) {
    this._panelOpened$.next(data);
    this.setBroadcastType(broadcastType || null);
    this.setPanelNotes({noSelectedNote: noSelectedNote || '', tableInitialText: undefined});
    this.setDefaultFilters(defaultFilters || null);
  }

  get panelNotes() {
    return this._panelNotes$;
  }

  setPanelNotes(data: UserSelectorPanelNotes) {
    this._panelNotes$.next({...this._panelNotes$.value, ...data});
  }

  get defaultFilters() {
    return this._defaultFilters$;
  }

  setDefaultFilters(data: { [k:string]: any } | null) {
    this._defaultFilters$.next(data);
  }

  openUserSelector() {
    this.setPanelStatus(true);
  }

  getOrgUserWithParams(orgId: number, userParams?: HttpParams, broadcastType?: string): Observable<GetOrgUserList> {
    if (this._defaultFilters$.value) {
      let defaultFilterData = this._defaultFilters$.value;
      if (!userParams) userParams = new HttpParams();

      if (userParams) {
        for (let key in defaultFilterData) {
          userParams = userParams.set(key, defaultFilterData[key]);
        }
      }
    }

    return this._httpService.getOrgUsersWithParams(orgId, userParams, broadcastType)
      .pipe(map(response => {
        if (typeof(response.page) == 'string') {
          response.page = parseInt(response.page);
        }
        if (typeof(response.limit) == 'string') {
          response.limit = parseInt(response.limit);
        }
        return response;
      }));
  }

}
